import {Component, Injectable, ViewContainerRef, TemplateRef } from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA, MdDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Rx';
// import {Validators} from '@angular/forms';
import { ComponentType } from '@angular/cdk/portal';
import { AppMessages } from '../constants/messages';
import { Utility } from '../../common/utility';
import { DialogComponent } from '../../components/dialog/dialog.component';

@Injectable()
export class DialogService {

  constructor(private dialog: MdDialog) {
  }

  public openSuccessDialog(data) {
    data['type'] = 1; // success
    const dialogRef = this.openDialog(data);
    return dialogRef.afterClosed();
  }

  public openErrorDialog(data) {
    data['type'] = 2; // 2:error
    const dialogRef = this.openDialog(data);
    return dialogRef.afterClosed();
  }

  public openConfirmationDialog(data): Observable<any> {
    data['type'] = 3; // confirm
    data['yesOption'] = false;
    const dialogConfig = this.getDialogConfig();
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    return dialogRef.afterClosed();
  }

  public getDialogConfig(){
    let config = new MdDialogConfig();
    config.disableClose = true;
    config.width = '600px';
    return config;
  }

  public openComponentDialog(componentOrTemplateRef, data?: Object, config?: MdDialogConfig): Observable<any> {
    let dialogConfig =  Object.assign({}, this.getDialogConfig(), config);
    if (data) {
      dialogConfig.data = data;
    }
    let dialogRef = this.dialog.open(componentOrTemplateRef, dialogConfig);
    return dialogRef.afterClosed();
  }

  openDialog(data) {
    let dialogConfig = this.getDialogConfig();
    dialogConfig.data = data;
    let dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    return dialogRef;
    //return dialogRef.afterClosed();
   /* dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;
    });*/
  }  
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/dialog.service.ts